(function () {
  'use strict';

  var activeDrawer = null;
  var activeTrigger = null;

  function focusable(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function setDrawerState(drawer, open, trigger) {
    if (!drawer) return;

    drawer.hidden = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('menu-open', open);

    if (trigger) {
      trigger.setAttribute('aria-expanded', String(open));
    }

    if (open) {
      activeDrawer = drawer;
      activeTrigger = trigger;
      var targets = focusable(drawer);
      if (targets.length) targets[0].focus();
    } else {
      var returnTarget = activeTrigger;
      activeDrawer = null;
      activeTrigger = null;
      if (returnTarget) returnTarget.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      var drawer = document.getElementById(toggle.getAttribute('aria-controls'));
      setDrawerState(drawer, toggle.getAttribute('aria-expanded') !== 'true', toggle);
      return;
    }

    var cartToggle = event.target.closest('[data-cart-drawer-toggle]');
    if (cartToggle) {
      event.preventDefault();
      var cartDrawer = document.getElementById(cartToggle.getAttribute('aria-controls'));
      setDrawerState(cartDrawer, true, cartToggle);
      return;
    }

    var close = event.target.closest('[data-menu-close]');
    if (close) {
      setDrawerState(document.getElementById(close.getAttribute('aria-controls')), false, activeTrigger);
      return;
    }

    if (activeDrawer && event.target === activeDrawer) {
      setDrawerState(activeDrawer, false, activeTrigger);
    }

    var quantityButton = event.target.closest('[data-quantity-step]');
    if (quantityButton) {
      var control = quantityButton.closest('[data-quantity-control]');
      var input = control && control.querySelector('input[type="number"]');
      if (!input) return;

      var step = Number(input.step || 1);
      var value = Number(input.value || input.min || step);
      var direction = Number(quantityButton.dataset.quantityStep);
      var minimum = Number(input.min || 1);
      var maximum = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(maximum, Math.max(minimum, value + direction * step)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (event) {
    var navigation = event.target.closest('[data-navigation-select]');
    if (navigation && navigation.value) window.location.assign(navigation.value);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeDrawer) {
      setDrawerState(activeDrawer, false, activeTrigger);
      return;
    }

    if (event.key !== 'Tab' || !activeDrawer) return;
    var targets = focusable(activeDrawer);
    if (!targets.length) return;

    var first = targets[0];
    var last = targets[targets.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:load', function () {
    document.body.classList.remove('menu-open');
    activeDrawer = null;
    activeTrigger = null;
  });
})();
